/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ExportNovaInsightsStatsCSV_viewer = {
    readonly missionControlData: {
        readonly companiesWithNovaInsights: ReadonlyArray<{
            readonly companyId: number | null;
            readonly companyName: string | null;
            readonly runningProjectsCount: number | null;
            readonly projectsInConnectedProjectCount: number | null;
            readonly timeRegProjectsCount: number | null;
            readonly doneTaskProjectsCount: number | null;
            readonly allocationProjectsCount: number | null;
            readonly estimatedProjectsCount: number | null;
            readonly predictedEndWithoutTimeRegAvailability: number | null;
            readonly predictedEndWithoutDoneTaskAvailability: number | null;
            readonly predictedEndWithoutAllocationAvailability: number | null;
            readonly predictedEndWithoutTimeRegDoneTaskAvailability: number | null;
            readonly predictedEndWithoutTimeRegDoneTaskAllocationAvailability: number | null;
            readonly predictedEndAvailability: number | null;
            readonly focusAvailability: number | null;
            readonly performanceAvailability: number | null;
            readonly novaInsightCompatibilityScore: number | null;
        } | null> | null;
    } | null;
    readonly " $refType": "ExportNovaInsightsStatsCSV_viewer";
};
export type ExportNovaInsightsStatsCSV_viewer$data = ExportNovaInsightsStatsCSV_viewer;
export type ExportNovaInsightsStatsCSV_viewer$key = {
    readonly " $data"?: ExportNovaInsightsStatsCSV_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ExportNovaInsightsStatsCSV_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "includeProjectGroups",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExportNovaInsightsStatsCSV_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MissionControlDataType",
      "kind": "LinkedField",
      "name": "missionControlData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "includeProjectGroups",
              "variableName": "includeProjectGroups"
            }
          ],
          "concreteType": "MissionControlCompanyNIStatsType",
          "kind": "LinkedField",
          "name": "companiesWithNovaInsights",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "runningProjectsCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectsInConnectedProjectCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "timeRegProjectsCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "doneTaskProjectsCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allocationProjectsCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "estimatedProjectsCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "predictedEndWithoutTimeRegAvailability",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "predictedEndWithoutDoneTaskAvailability",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "predictedEndWithoutAllocationAvailability",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "predictedEndWithoutTimeRegDoneTaskAvailability",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "predictedEndWithoutTimeRegDoneTaskAllocationAvailability",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "predictedEndAvailability",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "focusAvailability",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "performanceAvailability",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "novaInsightCompatibilityScore",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = '6fd3d0227734b89059f2022b788b4a26';
export default node;
